module.exports = __webpack_public_path__ + "img/패스킥슛.de8d678f.svg";